import { render, staticRenderFns } from "./IconJbjb.vue?vue&type=template&id=52273fc8"
import script from "./IconJbjb.vue?vue&type=script&lang=js"
export * from "./IconJbjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports